import { render, staticRenderFns } from "./ArrowNoticeIcon.vue?vue&type=template&id=6c5fd9e3&scoped=true"
import script from "./ArrowNoticeIcon.vue?vue&type=script&lang=js"
export * from "./ArrowNoticeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5fd9e3",
  null
  
)

export default component.exports